import React, { FC } from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { IAccrualBenefitTransactionDTO, IAccrualDetailedBalanceDTO, IAccrualSummaryDTO } from 'src/api/dtos';
import { useTranslate } from 'src/shared/providers';

import { AccrualDetailsGrid } from './AccrualDetailsGrid';

interface Props {
  benefitPackageName: IAccrualSummaryDTO['benefitPackageName'] | undefined;
  currentAccrual: IAccrualDetailedBalanceDTO | undefined;
  benefitTransactions: IAccrualBenefitTransactionDTO[] | undefined;
  loading?: boolean;
}

export const AccrualDetailsSection: FC<Props> = ({
  benefitPackageName,
  currentAccrual,
  benefitTransactions = [],
  loading,
}) => {
  const { t } = useTranslate();

  return (
    <Stack direction="column" spacing={2}>
      {currentAccrual ? (
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography fontWeight={600} variant="body1">
            {currentAccrual.benefitName} - {t('accrualSummary.balanceDetails')}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            ({t('accrualSummary.assignedBenefitPackage')} -{' '}
            <Typography variant="body2" component="span" color="text.primary">
              {benefitPackageName}
            </Typography>
            )
          </Typography>
        </Stack>
      ) : (
        <Typography fontWeight={600} variant="body1">
          {t('accrualSummary.balanceDetails')}
        </Typography>
      )}

      <Stack direction="column" spacing={2} width="100%">
        <AccrualDetailsGrid rows={benefitTransactions} loading={loading} />
      </Stack>
    </Stack>
  );
};
